const meta = {
  dashboards: 'Dashboards',
  services: 'Services',
  traces: 'Traces',
};

export default meta;
